import React, { Component } from 'react';
import { Switch, Redirect, Router } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { history } from '../../_utils/history';

import { Bank, Admin, Opd, Verificator} from '../../_utils/Permission';
// import Admin from '../../_utils/Admin';
// import Opd from '../../_utils/Opd';
// import Verificator from '../../_utils/Verificator';

import AdminView from './views/admin/admin.view';
import BankView from './views/bank/bank.view';
import OpdView from './views/opd/opd.view';
import VerificatorView from './views/verificator/verificator.view';

import { isLogged, isVerificator, isAdmin, isBank, isOpd } from '../../_utils/localstorage';
import LoginForm from './LoginForm';

export default class Content extends Component {

   render() {
      const to = () => {
         if(isAdmin()) return "/a";
         else if(isOpd()) return "/b";
         else if(isBank()) return "/c";
         else if(isVerificator()) return "/d";
         else return "/";
      }
      return (
         <Grid.Column width={16}>
            {!isLogged() && <LoginForm />}
            <Router history={history}>
               <Switch>
                  
                  <Admin
                     path="/a"
                     exact={false}
                     component={AdminView}
                  />
                  <Opd
                     path="/b"
                     exact={false}
                     component={OpdView}
                  />
                  <Bank
                     path="/c"
                     exact={false}
                     component={BankView}
                  />
                  <Verificator
                     path="/d"
                     exact={false}
                     component={VerificatorView}
                  />
                  <Redirect to={to()} />
               </Switch>
            </Router>
         </Grid.Column>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/Content.js